import React, { useCallback } from 'react';
import { usePlayer } from '../music/PlayerContext';
import './MobileMiniPlayer.css';

const PlayIcon = () => <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M8 5v14l11-7z"/></svg>;
const PauseIcon = () => <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg>;
const NextChevron = () => <span className="mobile-mini-next-icon">&gt;</span>;

function MobileMiniPlayer() {
  const { tracks, currentIndex, setCurrentIndex, isPlaying, setIsPlaying, shuffleOn } = usePlayer();
  const currentTrack = tracks[currentIndex];

  const getNextIndex = useCallback((curr) => {
    if (!tracks.length) return 0;
    if (shuffleOn && tracks.length > 1) {
      let n;
      do { n = Math.floor(Math.random() * tracks.length); } while (n === curr);
      return n;
    }
    return (curr + 1) % tracks.length;
  }, [shuffleOn, tracks.length]);

  const handleNext = useCallback(() => {
    if (!tracks.length) return;
    setCurrentIndex(getNextIndex(currentIndex));
    setIsPlaying(true);
  }, [tracks.length, currentIndex, getNextIndex, setCurrentIndex, setIsPlaying]);

  const handleToggle = useCallback(() => {
    if (!currentTrack) return;
    setIsPlaying(prev => !prev);
  }, [currentTrack, setIsPlaying]);

  return (
    <div className="mobile-mini-player">
      <div className="mobile-mini-art">
        <img
          src={currentTrack?.cover_art || process.env.PUBLIC_URL + '/playlist-thumbnail.png'}
          alt=""
          className="mobile-mini-art-img"
        />
      </div>
      <div className="mobile-mini-info">
        <span className="mobile-mini-title">{currentTrack?.title ?? '—'}</span>
      </div>
      <div className="mobile-mini-controls">
        <button
          type="button"
          className="mobile-mini-btn"
          onClick={handleToggle}
          disabled={!currentTrack}
          title={isPlaying ? 'Pause' : 'Play'}
        >
          {isPlaying ? <PauseIcon /> : <PlayIcon />}
        </button>
        <button
          type="button"
          className="mobile-mini-btn"
          onClick={handleNext}
          disabled={!currentTrack}
          title="Next"
        >
          <NextChevron />
        </button>
      </div>
    </div>
  );
}

export default MobileMiniPlayer;
